import { useState } from "react";
import { api } from "../api";
import { AuthShell } from "./AuthShell";

export function Login({ onDone }: { onDone: () => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(username, password);
      onDone();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Anmelden" lede="Mit deinem Zugang den Posteingang öffnen.">
      <form onSubmit={submit}>
        <div className="field">
          <label htmlFor="u">Benutzername</label>
          <input id="u" className="input" autoFocus autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="p">Passwort</label>
          <input id="p" className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>

        <button className="btn primary" disabled={busy || !username || !password}>
          {busy ? "Wird geprüft …" : "Anmelden"}
        </button>
        {error && <p className="error" role="alert">{error}</p>}
      </form>
    </AuthShell>
  );
}
